import { useQuery } from "@apollo/client";
import { SxProps, Theme } from "@mui/material";
import _ from "lodash";
import { ReactElement } from "react";

import {
  GetCreatomateTemplatePreviewLinkQuery,
  GetCreatomateTemplatePreviewLinkQueryVariables,
} from "~frontend/__generated__/graphql";
import ErrorCard from "~frontend/components/ErrorCard";
import { GifWithLoadingState } from "~frontend/components/personalizedGifs/GifWithLoadingState";
import { GET_CREATOMATE_TEMPLATE_PREVIEW_LINK } from "~frontend/graphql/personalizedGifs";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

import { CreatomateTemplate } from "./types";

export function TemplatePreview({
  template,
  customFields = {},
  customColors = {},
  logoUrl = null,
  onClick,
  pauseOnMouseOff,
  sx,
}: {
  template: CreatomateTemplate;
  customFields?: Record<string, string>;
  customColors?: Record<string, string>;
  logoUrl?: string | null;
  onClick?: () => any | Promise<any>;
  pauseOnMouseOff?: boolean;
  sx?: SxProps<Theme>;
}): ReactElement {
  const { subaccount } = useSubaccount()!;

  const { data, loading, error } = useQuery<
    GetCreatomateTemplatePreviewLinkQuery,
    GetCreatomateTemplatePreviewLinkQueryVariables
  >(GET_CREATOMATE_TEMPLATE_PREVIEW_LINK, {
    variables: {
      input: {
        subaccountId: subaccount.id,
        creatomateTemplateId: template.id,
        customFields: customFields ? JSON.stringify(customFields) : null,
        customColors: customColors ? JSON.stringify(customColors) : null,
        logoUrl,
      },
    },
  });

  if (error) {
    return <ErrorCard errors={["Error loading personalized GIF"]} />;
  }

  return (
    <GifWithLoadingState
      loading={loading}
      gifUrl={data?.getCreatomateTemplatePreviewLink.gifUrl ?? ""}
      pngUrl={data?.getCreatomateTemplatePreviewLink.pngUrl ?? ""}
      pauseOnMouseOff={pauseOnMouseOff}
      sx={{ width: "240px", height: "240px", ...sx }}
      onClick={onClick}
    />
  );
}
